<div class="tooltip-black">
  <a><i class="fa-solid fa-circle-question"></i></a>
  <span class="tooltiptext"><ng-content></ng-content></span>
</div>
